/* Braver ücret bekçisi: kişiye özel şapka satırındaki _ucret_kilit özelliği
   ("variantIdxAdet,variantIdxAdet") hangi ücret satırlarının bulunması
   gerektiğini söyler. Müşteri ücret satırını siler/sıfırlarsa eksik kalan
   ücretler sepete otomatik geri eklenir. (Tema kontrolleri zaten gizli;
   bu, /cart/change gibi doğrudan yollar için güvenlik ağıdır.) */
(function () {
  var busy = false;

  function check() {
    if (busy) return;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var need = {};
        cart.items.forEach(function (it) {
          var k = it.properties && it.properties["_ucret_kilit"];
          if (!k) return;
          String(k).split(",").forEach(function (pair) {
            var m = String(pair).split("x");
            var id = parseInt(m[0], 10);
            var q = parseInt(m[1], 10) || 0;
            if (id && q > 0) need[id] = (need[id] || 0) + q;
          });
        });
        // Ücret satırları (_Ücret özellikli) ihtiyaçla EŞİTLENİR:
        // eksikse eklenir, şapkası silinip sahipsiz kaldıysa azaltılır/silinir
        var duzeltmeler = []; // {id: satır anahtarı, quantity: olması gereken}
        function ucretSatiri(it) {
          if (it.properties && it.properties["_Ücret"]) return true;
          return /ücret/i.test(it.product_title || ""); // eski/etiketiz ücret satırları
        }
        cart.items.forEach(function (it) {
          if (!ucretSatiri(it)) return;
          var gerek = need[it.variant_id] || 0;
          var al = Math.min(it.quantity, gerek);
          need[it.variant_id] = gerek - al;
          if (al !== it.quantity) duzeltmeler.push({ id: it.key, quantity: al });
        });
        var missing = [];
        Object.keys(need).forEach(function (id) {
          if (need[id] > 0) missing.push({
            id: Number(id),
            quantity: need[id],
            properties: { "_Ücret": "Otomatik tamamlandı" }
          });
        });
        if (!duzeltmeler.length && !missing.length) return;
        busy = true;
        var zincir = Promise.resolve();
        duzeltmeler.forEach(function (dz) {
          zincir = zincir.then(function () {
            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify(dz)
            });
          });
        });
        if (missing.length) {
          zincir = zincir.then(function () {
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ items: missing })
            });
          });
        }
        zincir.then(function () {
          busy = false;
          if (/\/cart(\/|$|\?)/.test(window.location.pathname + "?")) window.location.reload();
        }).catch(function () { busy = false; });
      })
      .catch(function () {});
  }

  document.addEventListener("DOMContentLoaded", check);

  // Sepet mutasyonlarından sonra tekrar denetle
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var p = origFetch.apply(this, arguments);
    try {
      var u = String((input && input.url) || input || "");
      if (/\/cart\/(change|update|add|clear)/.test(u)) {
        p.then(function () { setTimeout(check, 400); }, function () {});
      }
    } catch (e) {}
    return p;
  };

  // Ödemeye geçiş öncesi son denetim
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('a[href*="checkout"], button[name="checkout"], [href="/checkout"]')) check();
  }, true);
})();
